import logoUrl from '@/assets/jemmi-logo.png';
import { cn } from '@/lib/cn';

type Size = 'sm' | 'md' | 'lg';

const heightClass: Record<Size, string> = {
  sm: 'h-7',
  md: 'h-9',
  lg: 'h-14',
};

type Props = {
  size?: Size;
  className?: string;
};

/**
 * Brand wordmark.
 *
 * Renders the PNG from /assets. Vite handles the asset URL and content-hash
 * caching automatically. If you ever swap to an SVG, replace the import and
 * keep the same props API.
 */
export function JemmiLogo({ size = 'md', className }: Props) {
  return (
    <img
      src={logoUrl}
      alt="Jemmi"
      draggable={false}
      className={cn('w-auto select-none', heightClass[size], className)}
    />
  );
}
